import { render, staticRenderFns } from "./protection.vue?vue&type=template&id=c3297ea2&"
import script from "./protection.vue?vue&type=script&lang=js&"
export * from "./protection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports